import template from './stBrowserAlerts.html';
import controller from './stBrowserAlerts.controller';

let stBrowserAlertsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default stBrowserAlertsComponent;



// WEBPACK FOOTER //
// ./client/app/common/stBrowserAlerts/stBrowserAlerts.component.js